import { createContext, useContext } from "react";
import { DateRange } from "../types/common";

export interface FilterValues {
  rangeDate: DateRange;
  idSourceFilter: string;
  originsSelected: any[];
  leadersSelected: any[];
  supervisorsSelected: any[];
  sellersSelected: any[];
  statesSelected: any[];
  channelsSelected: any[];
  clientsSelected: any[];
  operationTypesSelected: any[];
}

export type FilterKey = keyof FilterValues;
export type FilterStatus = "off" | "on" | "pending";

const FILTER_KEYS: FilterKey[] = [
  "originsSelected",
  "leadersSelected",
  "supervisorsSelected",
  "sellersSelected",
  "statesSelected",
  "channelsSelected",
  "clientsSelected",
  "operationTypesSelected",
  "idSourceFilter",
  "rangeDate",
];

const dayOf = (date: Date | null) => (date ? date.toDateString() : "");

const isTodayOnly = (range: DateRange) => {
  const today = new Date().toDateString();
  return dayOf(range.start) === today && dayOf(range.end) === today;
};

const isSet = (values: FilterValues, key: FilterKey) => {
  if (key === "rangeDate") return !isTodayOnly(values.rangeDate);
  if (key === "idSourceFilter") return Boolean(values.idSourceFilter);
  return (values[key] as any[]).length > 0;
};

// Por valor: marcar y desmarcar una opción arma otra lista, igual a la aplicada, y no es un cambio.
const isSame = (draft: FilterValues, applied: FilterValues, key: FilterKey) => {
  if (key === "rangeDate") {
    return dayOf(draft.rangeDate.start) === dayOf(applied.rangeDate.start) && dayOf(draft.rangeDate.end) === dayOf(applied.rangeDate.end);
  }
  return JSON.stringify(draft[key]) === JSON.stringify(applied[key]);
};

export const defaultFilters = (rangeDate: DateRange): FilterValues => ({
  rangeDate,
  idSourceFilter: "",
  originsSelected: [],
  leadersSelected: [],
  supervisorsSelected: [],
  sellersSelected: [],
  statesSelected: [],
  channelsSelected: [],
  clientsSelected: [],
  operationTypesSelected: [],
});

export const pendingFilters = (draft: FilterValues, applied: FilterValues) =>
  FILTER_KEYS.filter(key => !isSame(draft, applied, key));

export const appliedFiltersCount = (applied: FilterValues) => FILTER_KEYS.filter(key => isSet(applied, key)).length;

export const filterStatuses = (applied: FilterValues, pending: FilterKey[]) => (key: FilterKey): FilterStatus => {
  if (pending.includes(key)) return "pending";
  return isSet(applied, key) ? "on" : "off";
};

export const FilterStatusContext = createContext<(key: FilterKey) => FilterStatus>(() => "off");

export const useFilterStatus = () => useContext(FilterStatusContext);
